class ChangeModel {
  static counter = 1;

  constructor(entityType, actionType, prevValue, nextValue, dependencies) {
    this.id = ChangeModel.counter;
    this.entityType = entityType;
    this.actionType = actionType;
    this.prevValue = prevValue;
    this.nextValue = nextValue;
    this.dependencies = dependencies;
    ChangeModel.counter += 1;
  }
}

export default ChangeModel;
